<div
  class="bg-white text-[#202B42] border rounded-xl z-50 p-3 text-sm flex flex-wrap"
  [class.left-0]="absolute"
  [class.top-full]="absolute"
  [class.mt-1]="absolute"
  [class.absolute]="absolute"
  [class.w-fit]="fullWidth"
  [class.p-0]="fullWidth"
  [class.border-0]="fullWidth"
>
  <div
    class="custom-gradient-bg custom-border-gradient rounded-xl px-2 py-2 items-center gap-2 flex text-sm w-fit truncate"
  >
    <app-user-profile-picture
      [imageUrl]="targetUser?.profileImageUrl"
      [size]="fullWidth ? 'md' : 'lg'"
      [className]="'size-10 rounded-full'"
      [shortId]="targetUser?.shortId || ''"
      class="shrink-0"
    ></app-user-profile-picture>

    <div
      class="flex flex-col max-w-[120px]"
      [class.w-full]="fullWidth"
      [class.max-w-\[150px\]]="fullWidth"
      [class.md\:max-w-\[300px\]]="fullWidth"
    >
      <span class="text-left font-bold truncate">
        {{ targetUser?.publicName || payerName }}
      </span>
      <span class="text-left text-gray-600 mt-1 font-normal text-sm truncate">
        {{ payerEmail }}
      </span>
    </div>

    @if (!fullWidth || targetUser) {
      <app-nicky-button
        (click)="!targetUser ? onEditName() : onViewProfile()"
        [variant]="'text'"
        [size]="'small-no-padding'"
        [iconLeft]="iconClass"
      ></app-nicky-button>
    }
  </div>
</div>
